export default __webpack_public_path__ + "static/media/7-observatorio.4fe2c533.png";